import React from 'react';
import {DataItem} from 'src/design-system';
import * as Yup from 'yup';
import {Text} from 'react-native';
import {Typography} from 'src/styles';
import {IDeveloperField} from 'dromo-uploader-react';
import RadioInput from 'src/hook-form-wrapper/radio-input';
import _ from 'lodash';

interface DisplayProps {
  value: string;
  label?: string;
}

interface Props {
  name?: string;
  label?: string;
  disabled?: boolean;
}

export const statusOptions = [
  {value: 'active', title: 'Active', label: 'Active'},
  {value: 'excluded', title: 'Excluded', label: 'Excluded'},
  {value: 'paused', title: 'Paused', label: 'Paused'},
];

export const Import = (
  key: string = 'state',
  prefix?: string,
): IDeveloperField => ({
  label: (prefix ? prefix + ' ' : '') + 'Billing Status',
  key,
  type: 'select',
  selectOptions: statusOptions,
  validators: [
    {
      validate: 'required',
    },
  ],
});

export const Value = (value: string) => {
  return _.capitalize(value);
};

export const Display = ({value, label}: DisplayProps) => {
  return (
    <DataItem>
      <Text style={[Typography.H6]}>{label ? label : 'Billing Status'}</Text>
      <Text style={[Typography.P3]}>{Value(value)}</Text>
    </DataItem>
  );
};

export const Input = ({name, label}: Props) => {
  return (
    <RadioInput
      name={(name ? name + '.' : '') + 'state'}
      label={label ? label : 'Billing Status'}
      required={false}
      items={statusOptions}
    />
  );
};

export const validation = () => Yup.string().required('Status is required');

export default Input;
